// core
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// services
import { RaptorDataService } from '../../services/raptor-data.service';

@Component({
  selector: 'open-raptor-mobile',
  templateUrl: './raptor-mobile.component.html',
  styleUrls: ['./raptor-mobile.component.scss']
})
export class RaptorMobileComponent implements OnInit {
  @Input() question!: any;
  @Input() form!: FormGroup;
  countryList: any[] = [];

  constructor(
    private raptorDataService: RaptorDataService
  ) { }

  ngOnInit() {
    this.countryList = this.raptorDataService.filterMobileDetails(this.question.settings?.country_alpha3);
  }
}
